<template>
  <div class="config-user-input">
    <v-text-field 
      v-if="!dropdown && !checkBox && !isNumber"
      v-model="inputVal"
      :disabled="isDisabled"
      :rules="rules"
      @input="valueUpdated(inputVal)"
    />
    <v-text-field 
      v-if="isNumber"
      v-model="inputVal"
      :disabled="isDisabled"
      :rules="rules"
      type="number"
      @input="valueUpdated(inputVal)"
    />
    <v-select
      v-if="dropdown"
      v-model="inputVal"
      item-text="label"
      :items="options"
      @change="valueUpdated(inputVal)"
    />
    <v-checkbox
      v-if="checkBox"
      v-model="inputVal"
      item-text="label"
      @change="valueUpdated(inputVal)"
    />
  </div>
</template>

<script>

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

export default {
  name: 'UserInput',
  mixins: [deviceConfigMixin],
  props: {
    value: {
      type: [String, Number, Array, Boolean],
      required: true
    },
    options: {
      type: Array,
      required: false,
      default: () => []
    },
    dropdown: {
      type: Boolean,
      required: false,
      default: () => false
    },
    checkBox: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isNumber: {
      type: Boolean,
      required: false,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      inputVal: ''
    }
  },
  watch: {
    value() {
      this.mapFormProps();
    }
  },
  mounted() {
    this.mapFormProps();
  },
  methods: {
    mapFormProps() {
      if (!this.dropdown) {
        this.inputVal = this.value != undefined ? this.value : '';
      } else {
        this.inputVal = this.options.find(option => {
          return option.xml === this.value;
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .v-text-field {
    padding-top: .5em !important;
    margin-top: 0 !important;
  }
  .v-messages {
    display: none !important;
  }
</style>